import storage from '@lib/services/storageService';
import { getTokenData } from './getTokenData';

export const isTokenLoginOnly = (token?: string | null): boolean => {
  if (!token) {
    return false;
  }
  try {
    const secondSegmentDecoded = getTokenData(token);
    return secondSegmentDecoded.roles?.includes('patientLoginOnly');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error decoding token'); // we don't have a token, so we can't send a log
  }

  return false;
};

export const isPatientLoginOnly = (): boolean => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const tokenFromLocalStorage = storage.getToken();
  const tokenFromUrl = urlSearchParams.get('token');
  const widgetUserId = urlSearchParams.get('user');

  const isTokenFromLocalStorageLoginOnly = tokenFromLocalStorage ? isTokenLoginOnly(tokenFromLocalStorage) : true;
  const isTokenFromUrlLoginOnly = tokenFromUrl ? isTokenLoginOnly(tokenFromUrl) : true;

  return isTokenFromLocalStorageLoginOnly && isTokenFromUrlLoginOnly && !widgetUserId;
};
